import { isPast, isValid } from 'date-fns';

/**
 * Verifica se um momento (data e hora) está no passado.
 *
 * @param {string} dateStr - Data no formato "DD/MM/AAAA" (ex: "25/04/2026").
 * @param {string} timeStr - Hora no formato "HH:MM" (ex: "08:33").
 * @returns {boolean} Retorna `true` se o momento for anterior ao agora, `false` caso contrário.
 * @throws {Error} Lança um erro se a data ou hora for inválida.
 */
export function checkMomentInPast(dateStr, timeStr) {
  // 1. Quebra as strings manualmente para evitar erros de tokens do parse
  // Supondo dateStr = "25/04/2026" e timeStr = "08:33"
  const [day, month, year] = dateStr.split('/').map(Number);
  const [hours, minutes] = timeStr.split(':').map(Number);

  // 2. Criamos o objeto Date nativo
  // Nota: O mês no JS nativo começa em 0 (Janeiro = 0, Abril = 3)
  const targetDate = new Date(year, month - 1, day, hours, minutes);

  // 3. Validamos se os números eram reais
  if (!isValid(targetDate)) {
    throw new Error('Data e hora inválida. Informar suporte');
  }

  // 4. Usamos o date-fns apenas para a lógica de comparação
  return isPast(targetDate);
}
